import { isEmpty, isNil } from "ramda";
import { toast } from "react-toastify";

import { getAnalysisSpatialData, getAssetPointsAdditionalData, getAssetPointsSerialData } from "../../../../api";

export const loadSpatialData = async ({ asset, dateList, measureName, data, assetData, setData, setLoading }) => {
  setLoading(true);
  try {
    const result = [];
    for (let i = 0; i < dateList.length; i++) {
      const date = dateList[i];
      const isDuplicatedDate = data.filter((d) => d.datetime === date).length > 0;
      if (!isDuplicatedDate) {
        const spatialDataResponse = await getAnalysisSpatialData(asset, date);
        if (
          !isNil(spatialDataResponse?.status) &&
          spatialDataResponse.status === 200 &&
          !isNil(spatialDataResponse.data)
        ) {
          const spatialData = { ...spatialDataResponse.data.data?.[0] };
          const newItem = {
            asset: spatialData.asset,
            datetime: spatialData.info.datetime,
            values: spatialData[measureName],
            //pk: assetData?.points.map((p) => p.pk),
            pk: spatialData[measureName].map((d, i) => i),
          };
          result.push(newItem);
        }
      }
    }
    await setData(result);
  } catch (error) {
    toast.error(error.message, { className: "toast-error" });
  }
  setLoading(false);
};

export const loadTemporalData = async ({
  asset,
  startIndex,
  endIndex,
  pkList,
  measureName,
  setTemporalDataList,
  setMinsWaterfall,
  setMaxsWaterfall,
  minsWaterfall,
  maxsWaterfall,
  setLoading,
  datetime,
  equipment,
  channel,
  substructure,
  period,
  maximum,
  alertMeasure,
  startDate,
  afterAlert,
  setAfterAlert,
  selectedEquipment,
  equipmentTypes,
  type,
  manualPk,
  intensityData,
  assetSensors,
}) => {
  try {
    const allSensorIDs = [];
    const allSensorIDsMeasurands = [];

    const equipmentData = equipmentTypes.find((et) => selectedEquipment.equipmentType === et.name);

    let response = [];
    if (equipmentData.measurands.includes(measureName)) {
      if (type === "unique") {
        for (let manualIndex = 0; manualIndex < manualPk.length; manualIndex++) {
          const newResponse = await getAssetPointsSerialData(
            asset.name,
            manualPk[manualIndex],
            manualPk[manualIndex],
            datetime,
            [measureName],
            equipment,
            channel,
            substructure,
            period,
            maximum,
            startDate,
            afterAlert,
          );
          response.push(newResponse);
        }
      } else {
        const newResponse = await getAssetPointsSerialData(
          asset.name,
          startIndex,
          endIndex,
          datetime,
          [measureName],
          equipment,
          channel,
          substructure,
          period,
          maximum,
          startDate,
          afterAlert,
        );
        response.push(newResponse);
      }
    }
    if (!isNil(intensityData) && !isEmpty(intensityData) && type === "unique") {
      const subIndex = selectedEquipment.channels[channel - 1].substructures.findIndex(
        (sub) => sub.name === substructure.name || sub === substructure,
      );
      const actualSensors = selectedEquipment.channels[channel - 1].substructures[subIndex].sensors;
      for (let indexSensor = 0; indexSensor < assetSensors.length; indexSensor++) {
        if (actualSensors.includes(assetSensors[indexSensor].sensor_ID)) {
          for (let indexMeasurand = 0; indexMeasurand < assetSensors[indexSensor].measurands.length; indexMeasurand++) {
            allSensorIDs.push(assetSensors[indexSensor].sensor_ID);
            allSensorIDsMeasurands.push([assetSensors[indexSensor].measurands[indexMeasurand]]);
            const addition = await getAssetPointsAdditionalData(
              asset.name,
              datetime,
              assetSensors[indexSensor].measurands[indexMeasurand], //medida
              equipment,
              period,
              maximum,
              channel,
              startDate,
              afterAlert,
              assetSensors[indexSensor].sensor_ID, //ID del sensor
              startIndex,
              endIndex,
            );
            response.push(addition);
          }
        }
      }
    }
    const result = [];
    let minValue = Infinity;
    let maxValue = Number.NEGATIVE_INFINITY;
    const auxMinus = response.length - allSensorIDsMeasurands.length;
    if (equipmentData.measurands.includes(measureName)) {
      for (let responseIndex = 0; responseIndex < response.length; responseIndex++) {
        if (
          !isNil(response[responseIndex]?.status) &&
          response[responseIndex].status === 200 &&
          !isNil(response[responseIndex].data)
        ) {
          const data = response[responseIndex].data?.data;
          if (!isNil(data.data)) {
            for (let i = 0, j = startIndex; i < data.data.length; i++, j++) {
              const item = data.data[i];
              if (!isNil(item[measureName])) {
                const values = item[measureName].map((item) => item.value);
                const min = Math.min(...values);
                const max = Math.max(...values);
                if (minValue > min) minValue = min;
                if (maxValue < max) maxValue = max;
                if (!isNil(data.limits) && !isNil(data.limits[measureName]) && i === 0) {
                  result.push({
                    values: item[measureName].map((v) => v.value),
                    datetimes: item[measureName].map((v) => v.datetime),
                    pk:
                      type === "unique"
                        ? pkList.slice(manualPk[responseIndex], manualPk[responseIndex] + 1)[i]
                        : pkList.slice(startIndex, endIndex + 1)[i],
                    measurand: measureName,
                    channel: channel,
                    limits: data.limits[measureName],
                  });
                } else {
                  result.push({
                    values: item[measureName].map((v) => v.value),
                    datetimes: item[measureName].map((v) => v.datetime),
                    pk:
                      type === "unique"
                        ? pkList.slice(manualPk[responseIndex], manualPk[responseIndex] + 1)[i]
                        : pkList.slice(startIndex, endIndex + 1)[i],
                    channel: channel,
                    measurand: measureName,
                  });
                }
              } else {
                for (
                  let indexMeasurand = 0;
                  indexMeasurand < allSensorIDsMeasurands[responseIndex - auxMinus].length;
                  indexMeasurand++
                ) {
                  const item = data.data[i];
                  if (!isNil(item[allSensorIDsMeasurands[responseIndex - auxMinus][indexMeasurand]])) {
                    const values = item[allSensorIDsMeasurands[responseIndex - auxMinus][indexMeasurand]].map(
                      (item) => item.value,
                    );
                    const min = Math.min(...values);
                    const max = Math.max(...values);
                    if (minValue > min) minValue = min;
                    if (maxValue < max) maxValue = max;
                    result.push({
                      sensor_ID: allSensorIDs[responseIndex - auxMinus],
                      values: item[allSensorIDsMeasurands[responseIndex - auxMinus][indexMeasurand]].map(
                        (v) => v.value,
                      ),
                      datetimes: item[allSensorIDsMeasurands[responseIndex - auxMinus][indexMeasurand]].map(
                        (v) => v.datetime,
                      ),
                      pk:
                        type === "unique"
                          ? pkList.slice(manualPk[0], manualPk[0] + 1)[i]
                          : pkList.slice(startIndex, endIndex + 1)[i],
                      measurand: allSensorIDsMeasurands[responseIndex - auxMinus][indexMeasurand],
                      channel: channel,
                    });
                    if (
                      Math.abs(minValue) > maxValue &&
                      allSensorIDsMeasurands[responseIndex - auxMinus][indexMeasurand] === "strain"
                    ) {
                      maxValue = Math.abs(minValue);
                      setMinsWaterfall({
                        ...minsWaterfall,
                        [allSensorIDsMeasurands[responseIndex - auxMinus][indexMeasurand]]: minValue,
                      });
                      setMaxsWaterfall({
                        ...maxsWaterfall,
                        [allSensorIDsMeasurands[responseIndex - auxMinus][indexMeasurand]]: maxValue,
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }

      if (Math.abs(minValue) > maxValue && measureName === "strain") {
        maxValue = Math.abs(minValue);
      }
      setMinsWaterfall({ ...minsWaterfall, [measureName]: minValue });
      setMaxsWaterfall({ ...maxsWaterfall, [measureName]: maxValue });
    } else {
      for (let index = 0; index < response.length; index++) {
        if (!isNil(response[index]?.status) && response[index].status === 200 && !isNil(response[index].data)) {
          const data = response[index].data?.data;
          if (!isNil(data.data)) {
            for (let i = 0, j = startIndex; i < data.data.length; i++, j++) {}
          }
        }
      }
    }

    setTemporalDataList(result);
  } catch (error) {
    console.log(error);
    toast.error(error.message, { className: "toast-error" });
  } finally {
    //if (measureName === "current_intensity" || startIndex !== endIndex) {
    setLoading(false);
    //}
    if (!afterAlert) {
      setAfterAlert(true);
    }
  }
};

export const spatialSelectHandler = ({
  data,
  start,
  end,
  setStartIndex,
  setEndIndex,
  measureName,
  setTemporalDataList,
  setEnvironmentalDataList,
  minsWaterfall,
  setMinsWaterfall,
  maxsWaterfall,
  setMaxsWaterfall,
  currentAsset,
  spatialDataList,
  setLoading,
  datetime,
  equipment,
  selectedEquipment,
  channel,
  substructure,
  period,
  maximum,
  alertMeasure,
  startDate,
  afterAlert,
  setAfterAlert,
  equipmentTypes,
  manualPk,
  intensityData,
  assetSensors,
}) => {
  setLoading(true);
  if (!afterAlert) {
    if (!(measureName === "strain" && alertMeasure === "leak")) {
      let i = start;
      let j = end;
      setStartIndex(i);
      setEndIndex(j);
      if (j - i >= 64) {
        let centerPoint = parseInt((j - i) / 2) + i;
        i = centerPoint >= 32 ? centerPoint - 32 : 0;
        centerPoint += 32;
        const count = data?.series?.[0]?.data?.length ?? 0;
        j = centerPoint < count ? centerPoint : count - 1;
      }
      if (i !== j) {
        loadTemporalData({
          asset: currentAsset,
          startIndex: i,
          endIndex: j,
          pkList: spatialDataList?.[0]?.pk?.slice(i, j + 1),
          measureName,
          setTemporalDataList,
          setMinsWaterfall,
          setMaxsWaterfall,
          minsWaterfall,
          maxsWaterfall,
          setLoading,
          datetime,
          equipment,
          channel,
          substructure,
          period,
          maximum,
          startDate,
          alertMeasure,
          afterAlert,
          setAfterAlert,
          selectedEquipment,
          type: !isNil(manualPk) && !isEmpty(manualPk) ? "unique" : "distinct",
          equipmentTypes,
          manualPk,
          intensityData,
          assetSensors,
        });
      }

      //if (i === j) {
      //  loadTemporalData({
      //    asset: currentAsset,
      //    pkList: spatialDataList?.[0]?.pk?.slice(i, j + 1),
      //    measureName: "current_intensity",
      //    setTemporalDataList: setEnvironmentalDataList,
      //    setMinsWaterfall,
      //    setMaxsWaterfall,
      //    minsWaterfall,
      //    maxsWaterfall,
      //    setLoading,
      //    datetime,
      //    equipment,
      //    period,
      //    maximum,
      //    channel,
      //    substructure,
      //    startIndex: null,
      //    startDate,
      //    alertMeasure,
      //    afterAlert,
      //    setAfterAlert,
      //    selectedEquipment,
      //    equipmentTypes,
      //  });
      //}
    } else {
      setLoading(false);
      alertMeasure = null;
    }
  } else {
    let i = start;
    let j = end;
    setStartIndex(i);
    setEndIndex(j);
    if (j - i >= 64) {
      let centerPoint = parseInt((j - i) / 2) + i;
      i = centerPoint >= 32 ? centerPoint - 32 : 0;
      centerPoint += 32;
      const count = data?.series?.[0]?.data?.length ?? 0;
      j = centerPoint < count ? centerPoint : count - 1;
    }
    loadTemporalData({
      asset: currentAsset,
      startIndex: i,
      endIndex: j,
      pkList: spatialDataList?.[0]?.pk,
      measureName,
      setTemporalDataList,
      setMinsWaterfall,
      setMaxsWaterfall,
      minsWaterfall,
      maxsWaterfall,
      setLoading,
      datetime,
      equipment,
      channel,
      substructure,
      period,
      maximum,
      startDate,
      alertMeasure,
      afterAlert,
      setAfterAlert,
      selectedEquipment,
      equipmentTypes,
      type: i === j ? "unique" : "distinct",
      manualPk,
      intensityData,
      assetSensors,
    });

    //if (i === j) {
    //  loadTemporalData({
    //    asset: currentAsset,
    //    pkList: spatialDataList?.[0]?.pk?.slice(i, j + 1),
    //    measureName: "current_intensity",
    //    setTemporalDataList: setEnvironmentalDataList,
    //    setMinsWaterfall,
    //    setMaxsWaterfall,
    //    minsWaterfall,
    //    maxsWaterfall,
    //    setLoading,
    //    datetime,
    //    equipment,
    //    period,
    //    maximum,
    //    channel,
    //    substructure,
    //    startIndex: null,
    //    startDate,
    //    alertMeasure,
    //    afterAlert,
    //    setAfterAlert,
    //    selectedEquipment,
    //    equipmentTypes,
    //  });
    //}
  }
};
